import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL } from './legalConfig';
import { openCookieSettings } from './CookieBanner';

export function CompanyPolicyLinks({ className = '', linkClassName = '', style, linkStyle }) {
  const cp = LEGAL.companyPolicies;
  return (
    <nav aria-label={cp.label} data-testid="company-policy-links" className={className} style={style}>
      <span>{cp.label}: </span>
      {cp.links.map((l) => (
        <a key={l.key} href={l.href} target="_blank" rel="noopener noreferrer" className={linkClassName}
          style={linkStyle} data-testid={`company-policy-${l.key}`}>{l.label}</a>
      ))}
    </nav>
  );
}

export default function LegalFooterLinks({ showRefund = true, style }) {
  const a = { marginRight: 14, textDecoration: 'underline', fontSize: 12 };
  return (
    <>
    <nav aria-label="Legal" data-testid="legal-footer-links" style={style}>
      <Link style={a} to={LEGAL.routes.pricing} data-testid="legal-link-pricing">Pricing</Link>
      <Link style={a} to={LEGAL.routes.terms}>Terms</Link>
      <Link style={a} to={LEGAL.routes.privacy}>Privacy</Link>
      <Link style={a} to={LEGAL.routes.cookies}>Cookies</Link>
      {showRefund && <Link style={a} to={LEGAL.routes.refund}>Refunds</Link>}
      <Link style={a} to="/help" data-testid="legal-link-help">Help</Link>
      <a style={a} href="https://razorpay.me/@headkeysoftwaretechnologiespr" target="_blank" rel="noopener noreferrer" data-testid="pay-us-link">Pay us</a>
      <button type="button" onClick={openCookieSettings}
        style={{ ...a, background: 'none', border: 0, padding: 0, cursor: 'pointer', color: 'inherit' }}>Cookie settings</button>
    </nav>
    <CompanyPolicyLinks style={{ fontSize: 12, marginTop: 6, ...(style || {}) }} linkStyle={a} />
    </>
  );
}
